/* Legacy cl-btn: 40px tall, 2px radius, no transitions (Clockify's snappy feel). */
.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: var(--cl-control-height);
  padding: 8.5px 10.5px;
  border: 1px solid transparent;
  border-radius: var(--cl-radius);
  font: inherit;
  font-size: var(--cl-fs-base);
  font-weight: var(--cl-fw-regular);
  line-height: var(--cl-lh-base);
  white-space: nowrap;
  cursor: pointer;
  transition: none;
  user-select: none;
}

.button:disabled {
  cursor: default;
  opacity: 0.65;
}

.button:focus-visible {
  outline: none;
  box-shadow: var(--cl-blue-focus-ring);
}

.upper {
  text-transform: uppercase;
}

.label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.md,
.lg {
  min-width: var(--cl-btn-min-width);
}

.sm {
  min-height: 28px;
  padding: 3px 8px;
  font-size: var(--cl-fs-base);
}

.lg {
  padding: 7px 14px;
  font-size: var(--cl-fs-lg);
}

.block {
  display: flex;
  width: 100%;
}

.primary {
  background: var(--cl-btn-primary-bg);
  border-color: var(--cl-btn-primary-bg);
  color: var(--cl-btn-primary-text);
}

.primary:hover:not(:disabled) {
  background: var(--cl-btn-primary-bg-hover);
  border-color: var(--cl-blue-hover-border);
}

.primary:active:not(:disabled) {
  background: var(--cl-btn-primary-bg-active);
  border-color: var(--cl-blue-active-border);
}

/* Clockify's "secondary" is the blue outline button. */
.secondary {
  background: var(--cl-btn-outline-bg);
  border-color: var(--cl-btn-outline-border);
  color: var(--cl-btn-outline-text);
}

.secondary:hover:not(:disabled) {
  border-color: var(--cl-btn-outline-hover-border);
  color: var(--cl-btn-outline-hover-text);
}

.default {
  background: var(--cl-btn-default-bg);
  border-color: var(--cl-btn-default-border);
  color: var(--cl-btn-default-text);
}

.default:hover:not(:disabled) {
  background: var(--cl-btn-default-hover-bg);
}

.text {
  min-width: 0;
  background: transparent;
  color: var(--cl-btn-text-color);
}

.text:hover:not(:disabled) {
  color: var(--cl-blue-link-hover);
}

.link {
  min-width: 0;
  min-height: 0;
  padding: 0;
  background: transparent;
  color: var(--cl-link);
}

.link:hover:not(:disabled) {
  color: var(--cl-link-hover);
  text-decoration: underline;
}

.danger {
  background: var(--cl-btn-danger-bg);
  border-color: var(--cl-btn-danger-bg);
  color: var(--cl-white);
}

.danger:hover:not(:disabled) {
  background: var(--cl-btn-danger-bg-hover);
  border-color: var(--cl-btn-danger-bg-hover);
}

.danger:active:not(:disabled) {
  background: var(--cl-btn-danger-bg-active);
}

.danger:focus-visible {
  box-shadow: var(--cl-btn-danger-focus-ring);
}

.loading {
  cursor: progress;
}

.spinner {
  color: currentColor;
}

/* ui-lib `ui-button--regular` (new settings UI): 32px, radius 8, light fill. Declared last so it beats the size
   classes, which are tuned for the legacy cl-btn. */
.regular {
  min-width: 0;
  min-height: 32px;
  padding: 0 12px;
  border-color: var(--ui-btn-secondary-border);
  border-radius: 8px;
  background: var(--ui-btn-secondary-bg);
  color: var(--ui-input-fg);
}

.regular:hover:not(:disabled) {
  background: var(--ui-btn-secondary-hover);
}

.regular:active:not(:disabled) {
  background: var(--ui-btn-secondary-active);
}
